import React from 'react';
import Icon, { IconProps } from '../Icon';

const HelpIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 50 51"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 25.4894C0 11.6805 11.1911 0.489395 25 0.489395C38.7435 0.489395 50 11.6805 50 25.4894C50 39.2983 38.8089 50.4894 25 50.4894C11.1911 50.4894 0 39.2983 0 25.4894ZM2.42134 25.4897C2.42134 37.9242 12.5653 48.0682 24.9999 48.0682C37.4344 48.0682 47.5784 37.9242 47.5784 25.4897C47.5784 13.0551 37.4999 2.91116 24.9999 2.91116C12.4999 2.91116 2.42134 13.0551 2.42134 25.4897ZM26.0473 37.5967C26.0473 38.3166 25.4583 38.9056 24.7384 38.9056C24.0185 38.9056 23.4295 38.3166 23.4295 37.5967C23.4295 36.8768 24.0185 36.2878 24.7384 36.2878C25.4583 36.2878 26.0473 36.8768 26.0473 37.5967ZM27.7488 25.6204C30.1703 24.1806 31.4792 22.0863 31.4792 19.7958C31.4792 16.1963 28.5996 13.3821 25.0001 13.3821C21.4007 13.3821 18.5211 16.2617 18.5211 19.8612C18.5211 20.5156 19.0446 21.0392 19.6991 21.0392C20.3535 21.0392 20.8771 20.5156 20.8771 19.8612C20.8771 17.6361 22.7096 15.8036 24.9347 15.8036C27.1598 15.8036 28.9923 17.6361 28.9923 19.8612C28.9923 21.6937 27.6179 22.9371 26.4399 23.657C24.0839 25.0968 23.5603 27.1256 23.6258 28.1727V31.1177C23.6258 31.7722 24.2148 32.2958 24.8692 32.2958C25.5237 32.2958 26.0473 31.7722 26.0473 31.1177V28.1073V27.9764C26.0473 27.9748 26.0472 27.9725 26.0472 27.9695C26.0452 27.8506 26.0247 26.642 27.7488 25.6204Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default HelpIcon;
